// Joya Headquarter — ordering pages (English). Same keys as orders.he.js.
export default {
  'joya.orders.title': 'Ordering & replenishment',
  'joya.orders.subAll': 'All locations',
  'joya.orders.generate': 'Generate recommendation',
  'joya.orders.generateGo': 'Generate',
  'joya.orders.generateAgain': 'Generate a new one anyway',
  'joya.orders.generateFor': 'Recommendation for: {name}',
  'joya.orders.openExisting': 'Open the existing draft',
  'joya.orders.existingDraft': 'There is already a draft for this location and date. You can open it or generate a new recommendation.',
  'joya.orders.manual': 'Empty list',
  'joya.orders.newGoesTo': 'A new list opens for {name}. To use another location, choose it at the top of the page.',
  'joya.orders.listDate': 'List date',
  'joya.orders.none': 'No lists to show.',
  'joya.orders.filter.open': 'Open',
  'joya.orders.filter.DRAFT': 'Drafts',
  'joya.orders.filter.APPROVED': 'Approved',
  'joya.orders.filter.ORDERED': 'Ordered',
  'joya.orders.filter.REJECTED': 'Rejected',
  'joya.orders.filter.all': 'All',
  'joya.orders.origin': 'Origin',
  'joya.orders.origin.RECOMMENDATION': 'System recommendation',
  'joya.orders.origin.MANUAL': 'Manual list',
  'joya.orders.origin.HISTORICAL_IMPORT': 'Past order (imported)',
  'joya.orders.lines': 'Items',
  'joya.orders.createdBy': 'Created',
  'joya.orders.approvedBy': 'Approved',
  'joya.orders.orderedBy': 'Ordered',
  'joya.orders.rejectedBy': 'Rejected',
  'joya.orders.noStockNote': 'The system does not know your current stock. Quantities are suggestions from past final lists and sales.',

  'joya.orders.listTitle': 'Order list',
  'joya.orders.workingLines': 'The list',
  'joya.orders.emptyList': 'The list is empty. Add items.',
  'joya.orders.lineOrigin.RECOMMENDED': 'recommended',
  'joya.orders.lineOrigin.ADDED': 'added by hand',
  'joya.orders.freeText': 'free text',
  'joya.orders.qty': 'Quantity',
  'joya.orders.qtyPh': 'qty',
  'joya.orders.unit': 'Unit',
  'joya.orders.recommended': 'recommended:',
  'joya.orders.setQtyOrRemove': 'No quantity — enter a quantity or remove the item before approval.',
  'joya.orders.why': 'Why?',
  'joya.orders.remove': 'Remove',
  'joya.orders.restore': 'Put back',
  'joya.orders.notSaved': 'not saved yet',
  'joya.orders.unsaved': 'You have unsaved changes',
  'joya.orders.qtyPositive': 'A quantity must be more than 0 (or remove the item)',
  'joya.orders.undoAll': 'Undo all',
  'joya.orders.saveFirst': 'Save your changes first',
  'joya.orders.approveList': 'Approve list',
  'joya.orders.addItem': 'Add item',
  'joya.orders.markOrdered': 'Mark as ordered',
  'joya.orders.reopen': 'Reopen for editing',
  'joya.orders.copyText': 'Copy list as text',
  'joya.orders.copied': 'Copied ✓',
  'joya.orders.removedLines_one': '1 item removed',
  'joya.orders.removedLines_other': '{count} items removed',
  'joya.orders.notDue_one': 'Not due yet — 1 item',
  'joya.orders.notDue_other': 'Not due yet — {count} items',
  'joya.orders.notDueHelp': 'Items you usually order, but by your normal rhythm it is not time to order them yet. You can add them.',
  'joya.orders.addToList': 'Add to list',
  'joya.orders.itemSearch': 'Item',
  'joya.orders.itemSearchHint': 'Search the catalog, or type a free name.',
  'joya.orders.freeTextHint': 'No catalog item chosen — the item is saved as free text.',
  'joya.orders.qtyOptional': 'You can leave it empty now, but a quantity is needed before approval.',
  'joya.orders.ex1': 'Add 2 boxes of lemons',
  'joya.orders.ex2': 'Why so many tomatoes?',
  'joya.orders.ex3': 'Remove the napkins',

  'joya.orders.why.manual': 'Added by hand — there is no recommendation for it.',
  'joya.orders.why.method': 'How the quantity was found',
  'joya.orders.why.weight': 'weight',
  'joya.orders.why.examples_one': '1 final list the system learned from',
  'joya.orders.why.examples_other': '{count} final lists the system learned from',
  'joya.orders.why.ratios_one': '1 ratio: quantity ordered ÷ dishes sold',
  'joya.orders.why.ratios_other': '{count} ratios: quantity ordered ÷ dishes sold',
  'joya.orders.method.SALES_RATIO': 'From sales (ordered per dish sold)',
  'joya.orders.method.HISTORY_MEDIAN': 'From the quantities you ordered before',
  'joya.orders.method.RECIPE_ESTIMATE': 'Estimate from recipes — not counted stock',
  'joya.orders.method.NONE': 'No basis for a quantity — fill it in yourself',
  'joya.orders.exStatus.ORDERED': 'ordered',
  'joya.orders.exStatus.APPROVED': 'approved only (lower weight)',
  'joya.orders.exStatus.HISTORICAL': 'past order',
  'joya.orders.reason.SHORTAGE': 'Shortage reported: {dates}',
  'joya.orders.reason.DUE_BY_INTERVAL': 'Due: {daysSince} days since the last order; you usually order every {medianInterval} days (limit: {threshold}).',
  'joya.orders.reason.NOT_DUE_BY_INTERVAL': 'Not due yet: {daysSince} days since the last order; you usually order every {medianInterval} days.',
  'joya.orders.reason.ORDERED_ONCE': 'Ordered only once ({date}, quantity {qty}) — not enough history for a quantity.',
  'joya.orders.reason.NO_HISTORY': 'No order history for this item at this location.',
  'joya.orders.reason.LINKED_SALES': '{units} dishes sold from {dishes} dishes that use this item ({from} – {to}).',
  'joya.orders.reason.daysMissing': 'Sales data is missing for {n} days.',
  'joya.orders.notes.SALES_WINDOW_INCOMPLETE': 'Sales data is missing for {daysMissing} days since the last order, so sales were not used.',
  'joya.orders.notes.NO_RECIPE_ESTIMATE': 'No recipe estimate: {reason}',
  'joya.orders.notes.OFTEN_REMOVED': 'You removed this item {removed} of {suggested} times it was suggested — so it is only to check.',
  'joya.orders.notes.NO_LINKED_DISHES': 'This item is not linked to any dish on the menu, so sales are not used.',

  'joya.orders.original': 'The original system recommendation',
  'joya.orders.originalHelp': 'What the system recommended, before any change. It never changes.',
  'joya.orders.section.SUGGESTED': 'Suggested',
  'joya.orders.section.CHECK': 'To check (quantity to fill in)',
  'joya.orders.section.NOT_DUE': 'Not due yet',
  'joya.orders.editLog': 'Change log',
  'joya.orders.act.ADD': 'Added',
  'joya.orders.act.REMOVE': 'Removed',
  'joya.orders.act.RESTORE': 'Put back',
  'joya.orders.act.SET_QTY': 'Quantity changed',
  'joya.orders.act.NOTE': 'Note',
  'joya.orders.act.APPROVE': 'List approved',
  'joya.orders.act.MARK_ORDERED': 'Marked as ordered',
  'joya.orders.act.REJECT': 'Rejected',
  'joya.orders.act.REOPEN': 'Reopened',
  'joya.orders.via.UI': 'on screen',
  'joya.orders.via.CHAT': 'in chat',

  'joya.orders.confirm.approve': 'Approve the list',
  'joya.orders.confirm.ordered': 'Mark the order as placed',
  'joya.orders.confirm.reject': 'Reject the list',
  'joya.orders.confirm.reopen': 'Reopen',
  'joya.orders.confirmBtn.approve': 'Approve',
  'joya.orders.confirmBtn.ordered': 'Yes, I ordered it',
  'joya.orders.confirmBtn.reject': 'Reject',
  'joya.orders.confirmBtn.reopen': 'Reopen',
  'joya.orders.confirmText.approve': 'After approval the list is saved as the final list and cannot be edited (you can reopen it). Nothing is sent to the supplier.',
  'joya.orders.confirmText.ordered': 'Mark this only if you really placed the order with the supplier. The system will use the list as a learning example.',
  'joya.orders.confirmText.reject': 'The list will not be used for ordering or for learning.',
  'joya.orders.confirmText.reopen': 'The list goes back to draft and you can edit it again.',

  'joya.short.title': 'Report a shortage',
  'joya.short.report': 'Report a shortage',
  'joya.short.item': 'What ran out?',
  'joya.short.itemHint': 'Search the catalog, or type a free name.',
  'joya.short.date': 'Date',
  'joya.short.submit': 'Send report',
  'joya.short.saved': 'Report saved ✓',
  'joya.short.savedFreeText': 'Saved as free text — it is not linked to a catalog item, so it does not affect recommendations.',
  'joya.short.noReportNote': 'No report does not mean the order was right — report every shortage you notice.',
  'joya.short.recent': 'Reports from the last 30 days',
  'joya.short.none': 'No reports.',
  'joya.short.freeText': 'free text',

  'joya.learned.title': 'What the system learned',
  'joya.learned.showingFirst': 'Showing {name}. To see another location, choose it at the top of the page.',
  'joya.learned.howTitle': 'How the system learns',
  'joya.learned.how1': 'Every final list (approved or ordered) is a learning example. A list that was really ordered counts more than one that was only approved.',
  'joya.learned.how2': 'Newer lists count more than older ones.',
  'joya.learned.how3': 'The quantity from sales is used only when there is sales data for every day since the previous order.',
  'joya.learned.how4': 'When there is not enough basis, the system does not invent a quantity — it leaves the item for you to check.',
  'joya.learned.how5': 'Each location is learned separately.',
  'joya.learned.how6': 'A final list shows how you order; it is not a measurement of real use.',
  'joya.learned.none': 'Nothing to show yet. After you approve lists (or import past orders), the system starts learning.',
  'joya.learned.examples_one': '1 example',
  'joya.learned.examples_other': '{count} examples',
  'joya.learned.lastOrdered': 'Last ordered',
  'joya.learned.interval': 'Days between orders (median)',
  'joya.learned.days': 'days',
  'joya.learned.typicalQty': 'Usual quantity (weighted median)',
  'joya.learned.ratio': 'Quantity per dish sold',
  'joya.learned.ratioN_one': 'from 1 order',
  'joya.learned.ratioN_other': 'from {count} orders',
  'joya.learned.noRatio': 'Not enough complete sales data to calculate',
  'joya.learned.removed': 'Removed by you / suggested',
};
